import { useEffect, useState } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { theme } from '../../../theme/theme';

import { frequencyOptions } from '../../../data/OptionValues';

const SoftwareUpdFrequencySelect = (props) => {

  const [updateFrequency, setSoftwareUpdFrequency] = useState(props.updateFrequency);

  const handleSoftwareUpdFrequencyChanged = (event) => {
    setSoftwareUpdFrequency(event.target.value);
    if (props.onChange) {
      props.onChange({"updateFrequency": event.target.value});
    } else {
      console.error("SoftwareUpdFrequency changed handler not defined");
    }
  };

  useEffect(() => {
    setSoftwareUpdFrequency(props.updateFrequency);
  }, [props.updateFrequency]);

  return (
    <TextField 
      select
      onChange={handleSoftwareUpdFrequencyChanged}
      disabled={props.disabled}
      value={updateFrequency ?? ''}
      fullWidth
      sx={{ 
        "& .MuiOutlinedInput-root":{"& > fieldset": {borderColor: theme.palette.secondary.main}},
        "& .MuiOutlinedInput-input":{color: 'white'},
        "& .MuiOutlinedInput-input.Mui-disabled":{WebkitTextFillColor: 'white'},
        "& .MuiSelect-icon":{color: 'white'},
        "& .Mui-disabled":{"& > .MuiSelect-icon": {color: 'inherit'}},
        textAlignLast: 'end'
      }}
    >
      {frequencyOptions?.sort((t1, t2) => {
        return t1.label < t2.label ? -1 : 1;
      }).map(op => {
        return <MenuItem key={op.value} value={op.value}>{op.label}</MenuItem>;
      })}
    </TextField>
  );
};

export default SoftwareUpdFrequencySelect;